/* eslint-disable guard-for-in */
import _ from 'lodash';
import { Cookies } from 'react-cookie';
import { deleteShopSubLocalities, deleteShopDistrict, deleteShopOpenCities } from 'src/apis/backend';
import { openErrorModal } from '../../actions';
import { removeDeliveryZone, updateDeliveryZone } from '../../apis/shop.service';
import {
  SUBLOCALITY_LEVEL_1,
  FIRST_LEVEL,
  SECOND_LEVEL,
  ERROR_UPDATE_DELIVERY_ZONE,
  ERROR_DELETE_DELIVERY_ZONE
} from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import { keyGenerator } from '../../utils/tools';
import { showNotification } from '../Notification/Notification.view';

const cookies = new Cookies();

export const initDataConfig = async (newProps, component) => {
  const { configurations, shopId } = newProps;
  const { shopId: oldShopId } = component.props;
  const { page } = component.state;
  const isMap = JSON.parse(new Cookies().get('isMap') || true);
  const { openCities: cities, deliveryZones = [] } = configurations;
  const currentCities = isMap ? deliveryZones : cities;
  component.setState({
    isMap,
    page: shopId !== oldShopId ? 0 : page,
    currentCities: _.orderBy(currentCities, ['priority'], ['asc'])
  });
};

export const handleChangePage = (event, page, tabName, component) => {
  component.setState({ [tabName]: page });
};

export const handleChangeRowsPerPage = (event, tabName, component) => {
  component.setState({ [tabName]: event.target.value });
};

export const handleUpdateCities = (e, type, cityName, typeZone, component) => {
  const { minimum = 0, userServicePrice: servicePrice = {}, name } = e;
  component.setState({
    updateCityModal: true,
    zoneLevel: type ? FIRST_LEVEL : SECOND_LEVEL,
    deliveryZone: {
      minimum,
      servicePrice,
      districtName: type ? '' : name,
      cityName: type ? name : cityName,
      typeZone
    }
  });
};

export const handleCreateCity = async (type, e, component) => {
  const { configurations } = component.props;
  const { openCities: cities = {} } = configurations;
  const { name: cityName = '' } = cities[e] || {};
  component.setState({
    zoneLevel: type,
    addCityModal: true,
    deliveryZone: {
      cityName,
      districtName: '',
      minimum: 0,
      servicePrice: {
        [[keyGenerator('FEE')]]: {
          priceOrder: 0,
          fees: 0
        }
      }
    }
  });
};

/* ///////////////////////////////////                     HANDLE SEND DATA                        /////////////////////////////////// */

export const handleSubmitRemoveCities = async component => {
  const { removeCity, cityName, zoneLevel, deliveryZone = {} } = component.state;
  const { typeZone } = deliveryZone;
  try {
    if (zoneLevel === FIRST_LEVEL) {
      await deleteShopOpenCities(removeCity);
    } else if (typeZone === SUBLOCALITY_LEVEL_1) {
      await deleteShopSubLocalities(cityName, removeCity)
    } else {
      await deleteShopDistrict(cityName, removeCity)

    }
  } catch (err) {
    sendCloudWatchAlert(`Could not delete delivery city ${err}`);
    openErrorModal(ERROR_DELETE_DELIVERY_ZONE);
  }
  component.setState({ removeModalOpen: false });
};

export const removeZone = (removeCity, component, cityName, type, typeZone) => {
  component.setState({
    removeCity: removeCity?.name?.replace(/\s+/g, '_'),
    cityName,
    zoneLevel: type ? FIRST_LEVEL : SECOND_LEVEL,
    deliveryZone: { ...component.state.deliveryZone, typeZone },
    anchorEl: null
  });
  const { showModal } = component.props;
  const { isMap } = component.state;
  const modalData = {
    color: 'danger',
    title: `Êtes-vous sûr(e) de vouloir supprimer la zone de livraison ${isMap ? `n°${removeCity.priority}` : removeCity.name
      } ?`,
    showCancelBtn: true,
    btnColor: 'danger',
    onClick: () => {
      isMap ? handleRemoveDeliveryZone(removeCity, component) : handleSubmitRemoveCities(component);
      showModal(null);
    },
    btnTxt: 'Supprimer'
  };
  showModal(modalData);
};

export const handleChangeExpend = (event, expanded, panel, component) => {
  const balise = event.target.localName;
  if (balise !== 'path' && balise !== 'svg') {
    component.setState({
      expanded: { [panel]: expanded }
    });
  }
};

export const handleCloseMenu = component => {
  component.setState({ anchorEl: null });
};

export const handleDisplayMenu = (event, index, component) => {
  component.setState({ anchorEl: event.currentTarget, index });
};

export const onChangeLayout = (value, component) => {
  cookies.set('isMap', value);
  const { configurations } = component.props;
  const { openCities: cities, deliveryZones = [] } = configurations;
  const currentCities = value ? deliveryZones : cities;
  component.setState({
    currentCities: _.orderBy(currentCities, ['priority'], ['asc']),
    isMap: value,
    page: 0
  });
};

export const handleRemoveDeliveryZone = async (zone, component) => {
  const { configurations = {} } = component.props;
  const { deliveryZones = {}, address } = configurations;
  const { location = {} } = address;
  try {
    await removeDeliveryZone(zone, deliveryZones);
    component.setState({
      selectedZone: {},
      center: {
        lng: parseFloat(location.longitude),
        lat: parseFloat(location.latitude)
      }
    });
  } catch (err) {
    sendCloudWatchAlert(`Could not delete delivery zone ${err}`);
    openErrorModal(ERROR_DELETE_DELIVERY_ZONE);
  }
};

export const handleUpdateDeliveryZone = (e, component) => {
  const {
    minimum = 0,
    deliveryFees: servicePrice = {},
    userCancelServicePrice: cancelPrice = {}
  } = e;
  component.setState({
    updateCityModal: true,
    anchorEl: null,
    deliveryZone: {
      minimum,
      servicePrice,
      cancelPrice,
      ...e
    }
  });
};

export const onLoadPolygon = (polygon, key, component) => {
  component.polygonRefs[key] = polygon;
  const infoWindow = new window.google.maps.InfoWindow();
  component.setState((prevState) => ({
    polygonInfoWindows: {
      ...prevState.polygonInfoWindows,
      [key]: infoWindow,
    },
  }));

};

export const onLoadCircle = (circle, key, component) => {
  component.circleRefs[key] = circle;
  const infoWindow = new window.google.maps.InfoWindow();
  component.setState((prevState) => ({
    circleInfoWindows: {
      ...prevState.circleInfoWindows,
      [key]: infoWindow,
    },
  }));
};

export const onCircleClick = (e, component) => {
  const { key } = e;
  if (component.circleRefs[key]) {
    const nextPath = component.circleRefs[key];
    let center = nextPath.getCenter();
    center = { latitude: center.lat(), longitude: center.lng(), radius: nextPath.radius };
    const radius = nextPath.getRadius();
    const infoWindow = component.state.circleInfoWindows[key];
    closeWindow(key, component.state.polygonInfoWindows);
    closeWindow(key, component.state.circleInfoWindows);
    if (infoWindow) {
      const angle = Math.random() * 360;
      const pointOnPerimeter = calculatePointOnCircle(center, radius, angle);
      const centerLatLng = new window.google.maps.LatLng(center.latitude, center.longitude);
      const pointLatLng = new window.google.maps.LatLng(pointOnPerimeter.latitude, pointOnPerimeter.longitude);
      const distanceFromCenter = window.google.maps.geometry.spherical.computeDistanceBetween(centerLatLng, pointLatLng);
      const distanceInKm = distanceFromCenter / 1000;
      const infoContent = `${distanceInKm.toFixed(2)} km`;
      infoWindow.setContent(infoContent);
      infoWindow.setPosition(pointLatLng);
      infoWindow.open(component.map, component.circleRefs[key]);
    }
  }
};

export const onEditCircle = async (e, component) => {
  const { key, data } = e;
  if (component.circleRefs[key]) {
    const nextPath = component.circleRefs[key];
    let center = nextPath.getCenter();
    center = { latitude: center.lat(), longitude: center.lng(), radius: nextPath.radius };

    if (!_.isEqual(center, data)) {
      onCircleClick(e, component)

      try {
        await updateDeliveryZone({ ...e, data: center });
        component.setState({ selectedZone: { ...e, data: center } });

        showNotification(
          'light',
          'ltr',
          'primary',
          '',
          `La zone de livraison a bien été modifiée.`,
          true
        );
      } catch (e) {
        sendCloudWatchAlert(`Could not add/update delivery zone ${e}`);
        openErrorModal(ERROR_UPDATE_DELIVERY_ZONE);
      }
    }
  }
};

function calculatePointOnCircle(center, radius, angle) {
  const pointOnPerimeter = window.google.maps.geometry.spherical.computeOffset(
    new window.google.maps.LatLng(center.latitude, center.longitude),
    radius,
    angle
  );
  return {
    latitude: pointOnPerimeter.lat(),
    longitude: pointOnPerimeter.lng()
  };
}

export const onEditPolygon = async (e, component) => {
  const { key, data } = e;
  if (component.polygonRefs[key]) {

    const nextPath = component.polygonRefs[key]
      .getPath()
      .getArray()
      .map(latLng => {
        return { latitude: latLng.lat(), longitude: latLng.lng() };
      });

    if (!_.isEqual(nextPath, data)) {
      try {
        await updateDeliveryZone({ ...e, data: nextPath });
        component.setState({ selectedZone: { ...e, data: nextPath } });
        onPolygonClick(e, component)

        showNotification(
          'light',
          'ltr',
          'primary',
          '',
          `La zone de livraison a bien été modifiée.`,
          true
        );
      } catch (e) {
        sendCloudWatchAlert(`Could not update delivery zone ${e}`);
        openErrorModal(ERROR_UPDATE_DELIVERY_ZONE);
      }
    }
  }
};

function computePolygonPerimeter(polygon) {
  let perimeter = 0;
  const path = polygon.getPath();
  const numPoints = path.getLength();

  for (let i = 0; i < numPoints - 1; i++) {
    const point1 = path.getAt(i);
    const point2 = path.getAt(i + 1);
    perimeter += window.google.maps.geometry.spherical.computeDistanceBetween(point1, point2);
  }

  perimeter += window.google.maps.geometry.spherical.computeDistanceBetween(path.getAt(0), path.getAt(numPoints - 1));

  return perimeter;
}

export const onPolygonClick = (e, component) => {
  const { key } = e;
  if (component.polygonRefs[key]) {
    const infoWindow = component.state.polygonInfoWindows[key];
    closeWindow(key, component.state.polygonInfoWindows);
    closeWindow(key, component.state.circleInfoWindows);

    if (infoWindow) {
      const perimeter = computePolygonPerimeter(component.polygonRefs[key]);
      const perimeterInKm = perimeter / 1000;
      const infoContent = `${perimeterInKm.toFixed(2)} km`;
      infoWindow.setContent(infoContent);
      infoWindow.setPosition(component.polygonRefs[key].getPath().getAt(0));
      infoWindow.open(component.map, component.polygonRefs[key]);
    }
  }
};

export const closeWindow = (key, infoWindows) => {
  Object.keys(infoWindows).forEach(otherKey => {
    if (otherKey !== key) {
      const otherInfoWindow = infoWindows[otherKey];
      otherInfoWindow.close();
    }
  });
};



